// extracted by mini-css-extract-plugin
module.exports = {"sk-bouncedelay":"styles__sk-bouncedelay___1ZAzN"};